var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:{ 'is-num': _vm.isNumeric },attrs:{"scope":"col","title":_vm.description || null}},[_c('span',{staticClass:"pi-th"},[_c('span',{staticClass:"pi-th__label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2),_vm._v(" "),(_vm.info || _vm.entry)?_c('pi-definition-tooltip',{attrs:{"info-key":_vm.info,"entry":_vm.entry,"label":_vm.text,"align":_vm.isNumeric ? 'right' : 'left'}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-385d8860","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/pi/piTh.vue
// module id = 1639
// module chunks = 0